module.exports = __webpack_public_path__ + "static/media/maintenance-corona-illustration.edec763f.svg";